/**
* IBM Confidential
* Licensed Materials - Property of IBM
* (C) Copyright IBM Corp. 2020, 2024 All Rights Reserved.
* US Government Users Restricted Rights - Use, duplication or
* disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
* */

import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from '../Utilities/i18n/i18n.js';

var Money = function Money(_ref) {
  var ariaLabelProp = _ref.ariaLabel;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var ariaLabel = ariaLabelProp || t('Money icon');
  return /*#__PURE__*/React.createElement("svg", {
    "aria-label": ariaLabel,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 72 72"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: "36",
    cy: "36",
    r: "36",
    fill: "#e9e9e9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5 50.6H12.4c-1.2 0-2.2-1-2.2-2.2V15.8c0-1.2 1-2.2 2.2-2.2h46.1c1.2 0 2.2 1 2.2 2.2v32.6c.1 1.2-1 2.2-2.2 2.2z",
    fill: "#d7d7d7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M58.5 49.5h-45c-1.2 0-2.2-1-2.2-2.2V15.8c0-1.2 1-2.2 2.2-2.2h45c1.2 0 2.2 1 2.2 2.2v31.5c.1 1.2-1 2.2-2.2 2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5 15c.4 0 .8.3.8.8v31.5c0 .4-.3.8-.8.8h-45c-.4 0-.8-.3-.8-.8V15.8c0-.4.3-.8.8-.8h45m0-1.5h-45c-1.2 0-2.2 1-2.2 2.2v31.5c0 1.2 1 2.2 2.2 2.2h45c1.2 0 2.2-1 2.2-2.2V15.8c.1-1.3-1-2.3-2.2-2.3z",
    fill: "#6d7182"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2 28.1H19c-.6 0-1-.4-1-1v-5.9c0-.6.4-1 1-1h6.2c.6 0 1 .4 1 1v5.9c0 .6-.5 1-1 1z",
    fill: "#d7d7d7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#6d7182",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M31.4 39.4H18m27.1-4.5H18m22.8 4.5h-5.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7 21.8v4.9h-5.2v-4.9h5.2m.5-1.5H19c-.6 0-1 .4-1 1v5.9c0 .6.4 1 1 1h6.2c.6 0 1-.4 1-1v-5.9c0-.6-.5-1-1-1zm39.1 38.5H1c-.4 0-.8-.3-.8-.8s.3-.8.8-.8h63.3c.4 0 .8.3.8.8s-.4.8-.8.8zm6.7 0h-3.1c-.4 0-.8-.3-.8-.8s.3-.8.8-.8H71c.4 0 .8.3.8.8s-.4.8-.8.8z",
    fill: "#6d7182"
  })));
};
Money.propTypes = {
  ariaLabel: PropTypes.string
};
var Money$1 = Money;

export { Money$1 as default };
